import type { StateConfig } from '@/entities/state/model/state.types'
import { withTutorialFallback } from '@/features/onboarding/lib'
import { apiFetch } from '@/shared/api'

/**
 * Fetches state configuration using the authenticated API.
 * If tutorial mode is active, returns mock data instead of making API call.
 * @returns A promise that resolves to the state configuration
 */
export async function fetchStateConfig() {
  return withTutorialFallback<StateConfig>(
    'stateConfig',
    () => apiFetch<StateConfig>('/configuration/states'),
  )
}
